import React, { useLayoutEffect, useState } from "react";
import { RetweetOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  Badge,
  Avatar,
  Col,
  Row,
  Spin,
  Button,
  Input,
  Form,
  Layout,
  Card,
  ColorPicker,
  Select,
} from "antd";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import {
  CREATE_SETTING,
  SETTING,
  IMAGE_BASE_URL,
  LOCATIONS,
} from "../../constants/api";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import ImageSelect from "../images/ImageSelect";
import LS_SERVICE from "../../utils/localStorage";
import { INV_THEME, THEME } from "../../constants/constent";
const { Option } = Select;

const Setting = () => {
  const { Content } = Layout;
  const [form] = Form.useForm();
  const [loading, setIsLoading] = useState(true);

  const [state, setState] = useState(null);

  const [color, setColor] = useState(THEME);

  const handleColorChange = (value) => {
    const selectedColor = value.toHex();
    setColor(selectedColor);
    console.log("Selected color:", selectedColor);
  };

  const [colorInv, setInvColor] = useState(INV_THEME);

  const handleInvColorChange = (value) => {
    const selectedColor = value.toHex();
    setInvColor(selectedColor);
    console.log("Selected Inv color:", selectedColor);
  };

  // State for Image selection
  const [selectedLogo, setSelectedLogo] = useState("");
  const [selectedLogoValue, setSelectedLogoValue] = useState(null);
  const [isLogoDialog, setIsLogoDialog] = useState(false);

  const [selectedFavicon, setSelectedFavicon] = useState("");
  const [selectedFaviconValue, setSelectedFaviconValue] = useState(null);
  const [isFaviconDialog, setIsFaviconDialog] = useState(false);

  // Image Selection Handlers
  const openLogoDialog = () => setIsLogoDialog(true);
  const closeLogoDialog = () => setIsLogoDialog(false);
  const openFaviconDialog = () => setIsFaviconDialog(true);
  const closeFaviconDialog = () => setIsFaviconDialog(false);

  const handleLogoDialogOk = (selectedImg) =>
    handleImageSelection(selectedImg, "logo");
  const handleFaviconDialogOk = (selectedImg) =>
    handleImageSelection(selectedImg, "favicon");

  const handleImageSelection = (selectedImg, type) => {
    if (selectedImg.length > 0) {
      const imagePath = selectedImg[0].filePath;
      if (type === "logo") {
        setSelectedLogo(selectedImg[0].id);
        setSelectedLogoValue(imagePath);
        form.setFieldsValue({ company_logo: imagePath });
      } else if (type === "favicon") {
        setSelectedFavicon(selectedImg[0].id);
        setSelectedFaviconValue(imagePath);
        form.setFieldsValue({ company_favicon: imagePath });
      }
    } else {
      displayMessage(ERROR_MSG_TYPE, "Image not selected");
    }
  };

  // Remove the Selected Image
  const removeSelectedImage = (type) => {
    if (type === "logo") {
      setSelectedLogo("");
      setSelectedLogoValue(null);
      form.setFieldsValue({ company_logo: "" });
    } else if (type === "favicon") {
      setSelectedFavicon("");
      setSelectedFaviconValue(null);
      form.setFieldsValue({ company_favicon: "" });
    }
  };

  useLayoutEffect(() => {
    getLocations();
    getSetting();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getLocations = (countryID, stateID) => {
    setIsLoading(true);
    const successFn = function (data) {
      setState(data.states);
      setIsLoading(false);
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    const url =
      LOCATIONS +
      (countryID ? countryID : "102") +
      (stateID ? `&state_id=${stateID}` : "");
    getAPI(url, successFn, errorFn);
  };
  const getSetting = () => {
    getAPI(SETTING, handleSettingSuccess, handleSettingError);
  };

  const handleSettingSuccess = (data) => {
    if (data.status) {
      const setting = data.data;
      const ls_settings = {
        logo: setting?.company_logo?.filePath || null,
        favicon: setting?.company_favicon?.filePath || null,
        company_name: setting.company_name || null,
        company_address: setting.company_address || null,
        company_email: setting.company_email || null,
        company_description: setting.company_description || null,
        company_phone: setting.company_phone || null,
        website: setting.website || "",
        theme: setting.theme || THEME,
      };
      if (LS_SERVICE.has(setting)) {
        LS_SERVICE.edit("setting", ls_settings);
      } else {
        LS_SERVICE.set("setting", ls_settings);
      }
      document.documentElement.style.setProperty(
        "--primary-color",
        "#" + ls_settings.theme,
      );
      form.setFieldsValue({
        company_name: setting.company_name,
        company_description: setting.company_description,
        company_phone: setting.company_phone,
        company_email: setting.company_email,
        company_address: setting.company_address,
        company_state: parseInt(setting.company_state ?? "1673"),
        company_gst: setting.company_gst,
        company_pancard: setting.company_pancard,

        website: setting.website,

        instagram: setting.instagram,
        youtube: setting.youtube,
        facebook: setting.facebook,
        tweeter: setting.tweeter,

        setup_charage_amount: setting.setup_charage_amount,
        invoice_series: setting.invoice_series,
        payment_secrit_key: setting.payment_secrit_key,
        payment_app_id: setting.payment_app_id,
        payment_webhooks_secret: setting.payment_webhooks_secret,
        online_accept: setting.online_accept,
        cod_accept: setting.cod_accept,
        smtp_email: setting.smtp_email,
        smtp_password: setting.smtp_password,
        theme: setting.theme,
        invoice_theme: setting.invoice_theme,

        header_scripts: setting.header_scripts,
        map_script_id: setting.map_script_id,
      });

      setColor(setting.theme);
      setInvColor(setting.invoice_theme);

      if (setting.company_logo) {
        setSelectedLogo(setting?.company_logo?.id);
        setSelectedLogoValue(setting?.company_logo?.filePath);
        form.setFieldsValue({ company_logo: setting?.company_logo?.filePath });
      }

      if (setting.company_favicon) {
        setSelectedFavicon(setting?.company_favicon?.id);
        setSelectedFaviconValue(setting?.company_favicon?.filePath);
        form.setFieldsValue({
          company_favicon: setting?.company_favicon?.filePath,
        });
      }
    } else {
      displayMessage(ERROR_MSG_TYPE, data.message);
    }
    setIsLoading(false);
  };

  const handleSettingError = () => {
    setIsLoading(false);
    displayMessage(ERROR_MSG_TYPE, "Unable to Get Detail");
  };

  const createSetting = (values) => {
    setIsLoading(true);
    const body = values;
    if (selectedLogo) body.company_logo = selectedLogo;
    if (selectedFavicon) body.company_favicon = selectedFavicon;
    body.theme = color;
    body.invoice_theme = colorInv;
    console.log("createSetting", body);

    postAPI(
      CREATE_SETTING,
      body,
      handleCreateSettingSuccess,
      handleCreateSettingError,
    );
  };

  const handleCreateSettingSuccess = (data) => {
    setIsLoading(false);
    displayMessage(SUCCESS_MESSAGE, data.message);
    getSetting();
  };

  const handleCreateSettingError = () => {
    setIsLoading(false);
    displayMessage(ERROR_MSG_TYPE, "Error while saving settings");
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Global Setting"
          bordered={true}
          extra={
            <Button
              style={{ marginTop: "5px", marginBottom: "5px" }}
              onClick={getSetting}
              type="primary"
              ghost
            >
              <RetweetOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            <Form onFinish={createSetting} form={form} layout="vertical">
              <Form.Item style={{ marginBottom: 0 }}>
                <Row gutter={[16, 16]}>
                  {/* Company Logo */}
                  <Col span={6}>
                    <Form.Item
                      name="company_logo"
                      label={
                        <span>
                          Company Logo{" "}
                          <span style={{ color: "red", fontWeight: "bold" }}>
                            *Pref Size (1550x358)
                          </span>
                        </span>
                      }
                    >
                      <Row>
                        <Col span={selectedLogo === "" ? 24 : 15}>
                          <Input
                            type="text"
                            readOnly
                            onClick={openLogoDialog}
                            value={
                              selectedLogo === ""
                                ? "Click to select image"
                                : selectedLogoValue
                            }
                            placeholder="Company Logo"
                          />
                        </Col>
                        {selectedLogo !== "" && (
                          <>
                            <Col span={3}>
                              <Badge>
                                <Avatar
                                  src={IMAGE_BASE_URL + selectedLogoValue}
                                  shape="circle"
                                  size="default"
                                />
                              </Badge>
                            </Col>
                            <Col span={3}>
                              <DeleteOutlined
                                onClick={() => removeSelectedImage("logo")}
                              />
                            </Col>
                          </>
                        )}
                      </Row>
                    </Form.Item>
                  </Col>
                  {/* Company Favicon */}
                  <Col span={6}>
                    <Form.Item
                      name="company_favicon"
                      label={
                        <span>
                          Company Favicon{" "}
                          <span style={{ color: "red", fontWeight: "bold" }}>
                            *Pref Size (380x411)
                          </span>
                        </span>
                      }
                    >
                      <Row>
                        <Col span={selectedFavicon === "" ? 24 : 15}>
                          <Input
                            type="text"
                            readOnly
                            onClick={openFaviconDialog}
                            value={
                              selectedFavicon === ""
                                ? "Click to select image"
                                : selectedFaviconValue
                            }
                            placeholder="Company Favicon"
                          />
                        </Col>
                        {selectedFavicon !== "" && (
                          <>
                            <Col span={3}>
                              <Badge>
                                <Avatar
                                  src={IMAGE_BASE_URL + selectedFaviconValue}
                                  shape="circle"
                                  size="default"
                                />
                              </Badge>
                            </Col>
                            <Col span={3}>
                              <DeleteOutlined
                                onClick={() => removeSelectedImage("favicon")}
                              />
                            </Col>
                          </>
                        )}
                      </Row>
                    </Form.Item>
                  </Col>
                  {renderFormFields(state)}
                  <Col span={2}>
                    <Form.Item name="theme" label="Theme">
                      <ColorPicker
                        defaultValue={color}
                        showText
                        allowClear
                        onChange={handleColorChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item name="invoice_theme" label="Invoice theme">
                      <ColorPicker
                        defaultValue={colorInv}
                        showText
                        allowClear
                        onChange={handleInvColorChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item name="map_script_id" label="Map Scripts ID">
                      <Input placeholder="Custom Map Scripts ID" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item name="header_scripts" label="Header Scripts">
                      <Input.TextArea
                        rows={8}
                        placeholder="Custom Header Scripts"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>
              <Row>
                <Col span={24}>
                  <Form.Item style={{ float: "right" }} label="" colon={false}>
                    <Button loading={loading} block htmlType="submit">
                      Save
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
      <ImageSelect
        key="logo"
        isOpen={isLogoDialog}
        onClose={closeLogoDialog}
        onOk={handleLogoDialogOk}
        fromMager={false}
      />
      <ImageSelect
        key="favicon"
        isOpen={isFaviconDialog}
        onClose={closeFaviconDialog}
        onOk={handleFaviconDialogOk}
        fromMager={false}
      />
    </Layout>
  );
};

const renderFormFields = (state) => {
  const formFields = [
    {
      name: "company_name",
      label: "Company Name",
      placeholder: "Company Name",
      required: true,
      regex: /^[a-zA-Z0-9\s,.'-]{3,}$/,
      errorMessage:
        "Company name must be at least 3 characters long and alphanumeric.",
    },
    {
      name: "company_description",
      label: "Company Description",
      placeholder: "Company Description",
      required: true,
    },
    {
      name: "company_phone",
      label: "Company Phone",
      placeholder: "Company Phone",
      required: true,
      regex: /^[0-9]{10}$/,
      errorMessage: "Please enter a valid 10-digit phone number.",
    },
    {
      name: "company_email",
      label: "Company Email",
      placeholder: "Company Email",
      required: true,
      regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      errorMessage: "Please enter a valid email address.",
    },
    {
      name: "company_address",
      label: "Company Address",
      placeholder: "Company Address",
      required: true,
    },
    {
      name: "company_state",
      label: "State",
      placeholder: "Select State",
      required: true,
      type: "select",
      options:
        state?.map((e) => ({
          value: e.id,
          label: e.name,
        })) || [],
    },
    {
      name: "company_gst",
      label: "Company GST NO.",
      placeholder: "Company GST",
      required: true,
      regex: /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/,
      errorMessage: "Please enter a valid 15-digit GST number.",
    },
    {
      name: "company_pancard",
      label: "Company Pan-Card",
      placeholder: "Company Pan-Card",
      required: true,
      regex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      errorMessage: "Please enter a valid PAN card number.",
    },
    {
      name: "website",
      label: "Website URL",
      placeholder: "Website URL",
      required: false,
    },
    {
      name: "instagram",
      label: "Instagram",
      placeholder: "Instagram",
      required: true,
    },
    {
      name: "youtube",
      label: "Youtube",
      placeholder: "Youtube",
      required: true,
    },
    {
      name: "facebook",
      label: "Facebook",
      placeholder: "Facebook",
      required: true,
    },
    {
      name: "tweeter",
      label: "Tweeter",
      placeholder: "Tweeter",
      required: true,
    },
    {
      name: "invoice_series",
      label: "Invoice Series",
      placeholder: "Invoice Series",
      required: true,
    },
    {
      name: "setup_charage_amount",
      label: "Setup Charage Amount",
      placeholder: "Setup Charage Amount",
      required: true,
    },
    
    {
      name: "payment_app_id",
      label: "Razorpay Key-ID",
      placeholder: "Razorpay Key-ID",
      required: true,
    },
    {
      name: "payment_secrit_key",
      label: "Razorpay Key-Secret",
      placeholder: "Razorpay Key-Secret",
      required: true,
    },
    {
      name: "payment_webhooks_secret",
      label: "Razorpay Webhooks-Secret",
      placeholder: "Razorpay Webhooks-Secret",
      required: true,
    },
    {
      name: "online_accept",
      label: "Razorpay ON/OFF",
      placeholder: "Select Razorpay Status",
      required: true,
      type: "select",
      options: [
        { label: "ON", value: 1 },
        { label: "OFF", value: 0 },
      ],
    },
    {
      name: "cod_accept",
      label: "COD ON/OFF",
      placeholder: "Select COD Status",
      required: true,
      type: "select",
      options: [
        { label: "ON", value: 1 },
        { label: "OFF", value: 0 },
      ],
    },
    {
      name: "smtp_email",
      label: "SMTP Email",
      placeholder: "SMTP Email",
      required: true,
      regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      errorMessage: "Please enter a valid email address.",
    },
    {
      name: "smtp_password",
      label: "SMTP Password",
      placeholder: "SMTP Password",
      required: true,
    },
  ];

  return formFields.map((field, index) => (
    <Col key={index} span={6}>
      <Form.Item
        name={field.name}
        label={field.label}
        rules={[
          {
            required: field.required,
            message: `${field.label} is required!`,
          },
          field.regex && {
            pattern: field.regex,
            message: field.errorMessage,
          },
        ].filter(Boolean)}
      >
        {field.type === "select" ? (
          <Select placeholder={field.placeholder}>
            {field.options.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        ) : (
          <Input placeholder={field.placeholder} />
        )}
      </Form.Item>
    </Col>
  ));
};

export default Setting;
